// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";

function NoAccessViewCmp(Props) {
  return React.createElement("h1", undefined, "Allocation Dashboard No access");
}

var make = NoAccessViewCmp;

export {
  make ,
  
}
/* react Not a pure module */
